import http from '@/utils/http';
const base_path = '/v2/tool/audience';

/**
 * 获取人群包列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getAudienceListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
